<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новая услуга ',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новая услуга',
			items: [],
            operator_tariff_uuid: '',
            trackBy: 'id',
            name: '',
            config: null,
            rate: 0,
            qnt: '',

            status: null,
            initStatus: [],
            status_options: [
                { id:'active',   name:'Активен' },
                { id:'wait',     name:'Ожидает активации' },
                { id:'disabled', name:'Отключен' },
            ],

            unit: null,
            initUnit: [],
            unit_option: [
                {id: 'minutes', name: 'Минуты'},
                {id: 'seconds', name: 'Секунды'},
                {id: 'symbols', name: 'Символы'},
            ],

            operator: null,
            initOperator: [],
            operators_options: [],

            product: null,
            initProduct: [],
            products_options: [],
		}
	},

    watch: {
        initUnit: {
            immediate: true,
            handler(values) {
                this.unit = this.unit_option.filter(x => values.includes(x[this.trackBy]));
                this.unit = this.unit[0];
            }
        },
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initOperator: {
            immediate: true,
            handler(values) {
                this.operator = this.operators_options.filter(x => values.includes(x[this.trackBy]));
                this.operator = this.operator[0];
            }
        },
        initProduct: {
            immediate: true,
            handler(values) {
                this.product = this.products_options.filter(x => values.includes(x[this.trackBy]));
                this.product = this.product[0];
            }
        }
    },

	computed: {
        tariff_item(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_ITEM'];
        },
        operators_list_data(){
            return this.$store.getters['operators/GET_OPERATORS_LIST_DATA'];
        },
        products_list_data(){
            return this.$store.getters['products/GET_PRODUCTS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        this.operator_tariff_uuid = this.$route.params.operator_tariff_uuid ? this.$route.params.operator_tariff_uuid : '';

        let copy = this.$route.params.copy ? this.$route.params.copy : null;

        await this.$store.dispatch('operators/FETCH_OPERATORS_LIST', {});
        this.operators_options = this.operators_list_data;

        await this.$store.dispatch('products/FETCH_PRODUCTS_LIST', {});
        this.products_options = this.products_list_data;

        if(this.operator_tariff_uuid !== ''){

            if(copy === null) {
                this.title = 'Редактирование услуги';
                document.title = appConfig.title + ' - ' + 'Редактирование услуги';
            }

            let data_send = {
                'uuid' : this.operator_tariff_uuid,
            }

            await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_ITEM', data_send);

            this.name = this.tariff_item.name;
            this.config = this.tariff_item.config;
            this.rate = this.tariff_item.rate;
            this.qnt  = this.tariff_item.qnt;

            this.status = this.tariff_item.status ? this.tariff_item.status : null;
            this.initStatus = [this.tariff_item.status] ;

            this.unit = this.tariff_item.unit;
            this.initUnit = [this.tariff_item.unit];

            this.operator = this.tariff_item.operator_id ? this.tariff_item.operator_id : null;
            if (this.operator !== null) {
                this.initOperator = [this.operator];
            }

            this.product = this.tariff_item.product_id ? this.tariff_item.product_id : null;
            if (this.product !== null) {
                this.initProduct = [this.product];
            }

            if(copy === true){
                this.operator_tariff_uuid = '';
            }
        }
	},

	methods: {

        async saveTariff(){

            let data_send = {
                'name'    : this.name,
                'rate'    : this.rate,
                'config'  : this.config,
                'status'  : this.status && this.status.id ? this.status.id : null,
                'operator_id' : this.operator && this.operator.id ? this.operator.id : null,
                'product_id'  : this.product && this.product.id ? this.product.id : null,
                'unit'    : this.unit && this.unit.id ? this.unit.id : null,
                'qnt'     : this.qnt,
            };

            let result = '';

            if(this.operator_tariff_uuid === ''){
                result = await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_CREATE', data_send);
            } else {
                data_send.uuid = this.operator_tariff_uuid;
                result = await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Operators.Tariffs'});
            }
        }
	}
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveTariff"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Название услуги"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Категория"
                                        label-for="product"
                                    >
                                        <multiselect
                                            id="product"
                                            :track-by="trackBy"
                                            v-model="product"
                                            :options="products_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Оператор"
                                        label-for="operator"
                                    >
                                        <multiselect
                                            id="operator"
                                            :track-by="trackBy"
                                            v-model="operator"
                                            :options="operators_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Ставка, руб"
                                        label-for="rate"
                                    >
                                        <b-form-input
                                            id="rate"
                                            type="text"
                                            v-model="rate"
                                            placeholder="Укажите стоимость"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Ед.измерения"
                                        label-for="unit"
                                    >
                                        <multiselect
                                            id="unit"
                                            v-model="unit"
                                            :options="unit_option"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Количество"
                                        label-for="qnt"
                                    >
                                        <b-form-input
                                            id="qnt"
                                            type="text"
                                            v-model="qnt"
                                            placeholder="Укажите количество"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Параметры"
                                        label-for="config"
                                    >
                                        <b-form-textarea
                                            id="config"
                                            v-model="config"
                                            rows="4"
                                        ></b-form-textarea>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
